export default __webpack_public_path__ + "static/media/report-copy.5583ca65.svg";